import axios from "axios";
import { getApi } from "./utils";

export default {
    namespaced: true,

    state: {
        workers: [],
        users: [],
    },

    getters: {
        workersList(state) {
            return state.workers.map((worker) => {
                const { id, name } = worker;
                return {
                    value: id,
                    label: name,
                };
            });
        },
        activeActorsList(state) {
            const workers = state.workers.map((worker) => {
                const { id, name, user_id } = worker;
                return {
                    value: `worker-${id}`,
                    workerId: id,
                    userId: user_id,
                    label: name,
                };
            });
            const usersWithoutWorker = state.users
                .filter((user) => !user.worker)
                .map((userData) => {
                    const { id, name } = userData.user;
                    return {
                        value: `user-${id}`,
                        workerId: null,
                        userId: id,
                        label: name,
                    };
                });

            const actors = [...workers, ...usersWithoutWorker];

            return actors;
        },
    },

    mutations: {
        setWorkers(state, list) {
            state.workers = list;
        },
        setUsers(state, list) {
            state.users = list;
        },
    },

    actions: {
        async getWorkers(ctx) {
            const { url, commit } = getApi(ctx);

            const { data } = await axios.get(
                url("api/worker/index", {
                    sort: "name",
                    pagination: 0,
                    job_status: 1,
                }),
            );

            commit("setWorkers", data);
            return data;
        },
        async getUsers(ctx) {
            const { url, commit } = getApi(ctx);

            const { data } = await axios.get(url("api/directory/users"));

            commit("setUsers", data);
            return data;
        },
        async getActiveActors(ctx) {
            const { dispatch } = getApi(ctx);

            return Promise.all([dispatch("getUsers"), dispatch("getWorkers")]);
        },
    },
};
